import translate from "utils/localisation";

export default function(text) {
  return translate(text);
}
